export default "__VITE_ASSET__B3aRhw2D__"